import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { colorBorder, colorText } from '@/utils/palette';

export const ModalHeaderWrap = styled(Modal.Header)`
  border-bottom: 1px solid ${colorBorder};
  padding: 18px 22px;
`;

export const ModalBodyWrap = styled(Modal.Body)`
  padding: 22px;
`;

export const ModalTitleText = styled.span`
  color: ${colorText};
  font-size: 18px;
  font-weight: 700;
`;

export const ModalFooterWrap = styled(Modal.Footer)`
  border-top: 1px solid ${colorBorder};

  .btn {
    margin-bottom: 0;
  }
`;
